<div class="date-range white-box main-black p-4 border-radius-bottom">
	<div class="border-bottom d-flex justify-content-between p-3">
		<h2>{{ 'admin.brm_potentially_malfunctioned_chargers' | translate }}</h2>
	</div>

	<div>
		<input
			type="checkbox"
			id="dateRange"
			[(ngModel)]="withCleared"
			(ngModelChange)="toggleWithCleared()"
		/>
		<label for="dateRange" class="m-2">{{ 'potentially_malfunctioned.show_removed_chargers' | translate }}</label>
	</div>

	<sct-custom-table
		[data]="tableData"
		[config]="tableConfig"
		[columnsConfig]="columnConfig"
	></sct-custom-table>
</div>

<app-modal
	[hasCloseButton]="true"
	[hasConfirmButton]="true"
	[confirmBtnText]="'g.remove' | translate"
	#removeDeviceModal title="{{'potentially_malfunctioned.remove' | translate}}"
	size="lg"
>
	<p>{{"potentially_malfunctioned.confirm_remove" | translate}}</p>
	<ul>
		<li>{{toRemoveDevice?.serial_number}}</li>
	</ul>
</app-modal>
